import { useWindowSize as e } from "../context/WindowSize/WindowDimensionsProvider.js";
import "../context/WindowSize/Dimensions.js";
import { maxPhoneWidth as t, maxTabletWidth as i } from "../utils/css/mediaQueries.js";
import { normaliseResponsiveProp as n } from "../utils/responsiveProps.js";
function f(o) {
  const { width: r } = e();
  return n(o)[m(r)];
}
const m = (o) => o <= t ? 0 : o <= i ? 1 : 2;
export {
  f as default
};
